import React from 'react';
import TextBackgroundColorField from './TextBackgroundColorField';

/** Champ Puck — fond d'une zone de texte riche (vide = transparent). */
export const puckTextBackgroundField = (label = 'Fond du texte') => ({
  type: 'custom',
  label,
  render: ({ onChange, value }) => (
    <TextBackgroundColorField value={value} onChange={onChange} label={label} />
  ),
});
